import { render, staticRenderFns } from "./detailSheet.vue?vue&type=template&id=052e8dbf&"
import script from "./detailSheet.vue?vue&type=script&lang=ts&"
export * from "./detailSheet.vue?vue&type=script&lang=ts&"
import style0 from "./detailSheet.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports